import React, { useState, useEffect } from 'react';
import '../assets/css/style.css';
import { Link, useLocation } from 'react-router-dom';
import logo from '../assets/images/logo.png';

const SECTIONS = ['index', 'skills', 'landingpage', 'process', 'about', 'projects', 'reviews', 'contact'];

const NAV_ITEMS = [
  { id: 'index', label: 'Inicio' },
  { id: 'skills', label: 'Skills' },
  { id: 'landingpage', label: 'Servicios' },
  { id: 'process', label: 'Proceso' },
  { id: 'about', label: 'Sobre Mí' },
  { id: 'projects', label: 'Proyectos' },
  { id: 'reviews', label: 'Reviews' },
  { id: 'contact', label: 'Contacto' },
];

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [activeSection, setActiveSection] = useState('index');
  const [scrolled, setScrolled] = useState(false);
  const location = useLocation();
  const isMainPage = location.pathname === '/';

  const handleScroll = (e, id) => {
    e.preventDefault();
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
    setIsMenuOpen(false);
  };

  // Scroll-spy
  useEffect(() => {
    if (!isMainPage) return;
    const observer = new IntersectionObserver(
      (entries) => entries.forEach((e) => e.isIntersecting && setActiveSection(e.target.id)),
      { rootMargin: '-50% 0px -50% 0px' }
    );
    SECTIONS.forEach((s) => { const el = document.getElementById(s); if (el) observer.observe(el); });
    return () => SECTIONS.forEach((s) => { const el = document.getElementById(s); if (el) observer.unobserve(el); });
  }, [isMainPage]);

  // Header background on scroll
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <>
      <style>{`
        .main-header {
          transition: background 0.4s, box-shadow 0.4s, backdrop-filter 0.4s;
        }
        .main-header.scrolled {
          background: rgba(10,10,10,0.92) !important;
          backdrop-filter: blur(16px);
          box-shadow: 0 1px 0 rgba(255,69,0,0.15);
        }
        .nav-link-item {
          color: rgba(242,242,242,0.65);
          text-decoration: none;
          font-size: 0.88rem;
          font-weight: 500;
          padding: 0.3rem 0;
          position: relative;
          transition: color 0.2s;
        }
        .nav-link-item::after {
          content: '';
          position: absolute;
          bottom: -2px;
          left: 0;
          width: 0;
          height: 2px;
          background: #ff4500;
          transition: width 0.25s;
          border-radius: 1px;
        }
        .nav-link-item:hover, .nav-link-item.active {
          color: #f2f2f2;
        }
        .nav-link-item.active::after, .nav-link-item:hover::after {
          width: 100%;
        }
        .ai-badge {
          display: inline-flex; align-items: center; gap: 0.4rem;
          padding: 0.25rem 0.7rem; border-radius: 20px;
          background: rgba(255,69,0,0.1); border: 1px solid rgba(255,69,0,0.3);
          color: #ff7b47; font-size: 0.75rem; font-weight: 600;
          cursor: pointer; transition: all 0.2s;
        }
        .ai-badge:hover { background: rgba(255,69,0,0.2); }
        @keyframes pulse-dot { 0%,100%{opacity:1} 50%{opacity:0.4} }
      `}</style>

      <header
        className={`main-header${scrolled ? ' scrolled' : ''}`}
        style={{
          position: 'fixed', top: 0, left: 0, right: 0, zIndex: 1000,
          background: 'transparent', padding: '0',
        }}
      >
        <nav
          className="navbar"
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'space-between',
            padding: '1rem 1.5rem', maxWidth: '1200px', margin: '0 auto',
          }}
        >
          {/* Logo */}
          <Link to="/" style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
            <img src={logo} alt="TinchoDev" style={{ height: '36px' }} />
          </Link>

          {/* Nav links */}
          <ul className={`nav-links ${isMenuOpen ? 'show' : ''}`} id="nav-links">
            {isMainPage ? (
              NAV_ITEMS.map(({ id, label }) => (
                <li key={id}>
                  <a
                    href={`#${id}`}
                    className={`nav-link-item${activeSection === id ? ' active' : ''}`}
                    onClick={(e) => handleScroll(e, id)}
                  >
                    {label}
                  </a>
                </li>
              ))
            ) : (
              <li><Link to="/" className="nav-link-item">← Inicio</Link></li>
            )}

            <li>
              <Link
                to="/code-showcase"
                className={`nav-link-item${location.pathname === '/code-showcase' ? ' active' : ''}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Demo IA
              </Link>
            </li>

            <li>
              <Link
                to="/agencia"
                className={`nav-link-item${location.pathname === '/agencia' ? ' active' : ''}`}
                onClick={() => setIsMenuOpen(false)}
              >
                Agencia IA
              </Link>
            </li>

            {/* AI Badge */}
            <li>
              <span
                className="ai-badge"
                onClick={() => document.querySelector('.ai-fab')?.click()}
                title="Abrir asistente IA"
              >
                <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#44ff88', animation: 'pulse-dot 2s infinite' }} />
                Asistente IA
              </span>
            </li>
          </ul>

          {/* Burger */}
          <div
            className={`burger ${isMenuOpen ? 'active' : ''}`}
            onClick={() => setIsMenuOpen(!isMenuOpen)}
            style={{ cursor: 'pointer' }}
          >
            <div className="line1" /><div className="line2" /><div className="line3" />
          </div>
        </nav>
      </header>

      {/* Spacer para compensar el header fijo */}
      <div style={{ height: '70px' }} />
    </>
  );
};

export default Header;
